import Header, { HeaderProps } from "./../Header";
import AdminAvatarMenu from "./AdminAvatarMenu";
import { AdminHeaderMenuProps } from "./AdminHeaderMenu";

export interface AdminHeaderProps extends HeaderProps {
  menuProps?: AdminHeaderMenuProps;
}

export default function AdminHeader({ menuProps, ...props }: AdminHeaderProps) {
  return (
    <Header
      right={<AdminAvatarMenu />}
      //content={<AdminHeaderMenu {...menuProps} />}
      {...props}
    />
  );
}
